(function() {
  const fitGuide = document.querySelector('.product-fit-guide')
  if (!fitGuide) return;

  fetchAndDisplayFitData(fitGuide);
})();

function fetchAndDisplayFitData(selector) {
  // Fetch reviews from Stamped.io's public reviews endpoint
  const shopUrl = theme.shopUrl;
  const productId = theme.productId;
  const publicKey = 'pubkey-QQj9Oo88kJBuHhd0NA5727w7k0D8TQ';
  const endpoint = 'https://stamped.io/api/widget/reviews';

  fetch(`${endpoint}?storeUrl=${shopUrl}&productId=${productId}&take=100&apiKey=${publicKey}`, { method: 'GET' })
    .then(response => response.json())
    .then(result => getFits(result.data))
    .then(fits => {
      console.log('fits');
      console.log(fits);
      outputFits(fits, selector);
    })
    .catch(err => console.log(err));
}

// Filter review data into just the grouped fit data
function getFits(data) {
  const reviewData = data.map(review => review.reviewOptionsList);
  const fitObj = {
    length: { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 },
    width: { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 },
    arch: { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 },
    total: 0
  };
  let total = 0;

  // Get values from reviewOptionsList array for length, width, and arch
  // Insert values into the fitObj object
  reviewData.forEach(item => {
    if (!item.length) return;
    total++; // Increment review total

    const lv = +item[0].value; // Length value of 1-5
    const wv = +item[1].value; // Width value of 1-5
    const av = +item[2].value; // Arch/support value of 1-5

    fitObj['length'][lv] = fitObj['length'][lv] + 1; // Increment fitObj -> length -> 1/2/3/4/5
    fitObj['width'][wv] = fitObj['width'][wv] + 1; // Increment fitObj -> width -> 1/2/3/4/5
    fitObj['arch'][av] = fitObj['arch'][av] + 1; // Increment fitObj -> arch -> 1/2/3/4/5
  });

  // Adjust "total" property in fitObj with final review number
  fitObj.total = total;

  return fitObj;
};

function outputFits(fitData, selector) {
  const { total } = fitData;
  if (total === 0) return; // Exit early if we have no reviews

  const fitLabels = {
    length: {
      1: 'Runs Full Size Small',
      2: 'Runs Half Size Small',
      3: 'True to Size',
      4: 'Runs Half Size Big',
      5: 'Runs Full Size Big'
    },
    width: {
      1: 'Runs Narrow',
      2: 'Runs Slightly Narrow',
      3: 'True to Size',
      4: 'Runs Slightly Wide',
      5: 'Runs Wide'
    },
    arch: {
      1: 'No Arch Support',
      2: 'Poor Arch Support',
      3: 'Moderate Arch Support',
      4: 'Good Arch Support',
      5: 'Great Arch Support'
    }
  };

  buildOutput(fitLabels, fitData, selector, total);
};

function buildOutput(fitLabels, fitData, selector, total) {
  const markup = `
    <div class="product-fit-guide__header">
      <strong>How's the fit?</strong>
      <button class="product-fit-guide__breakdown-toggle">View Breakdown</button>
    </div>
    <div class="product-fit-guide__preview"></div>
    <div class="product-fit-guide__breakdown product-fit-guide__breakdown--hidden">
      <div class="product-fit-guide__breakdown-category-wrap">
      </div>
      <div class="product-fit-guide__breakdown-message">
        <i aria-hidden="true"></i>
        <span>
          All fit data is provided by valued customers like you!
        </span>
      </div>
    </div>
  `;

  selector.innerHTML = markup;
  const preview = selector.querySelector('.product-fit-guide__preview');
  const breakdown = selector.querySelector('.product-fit-guide__breakdown');
  const breakdownWrap = selector.querySelector('.product-fit-guide__breakdown-category-wrap');
  const breakdownToggle = selector.querySelector('.product-fit-guide__breakdown-toggle');
  const fitScroll = document.querySelector('.how-does-it-fit'); // "How does it fit?"" text

  // Loop through length, width, and arch and build the HTML output
  for (const fit in fitLabels) {
    const title = capitalize(fit);
    const labels = fitLabels[fit];
    const data = fitData[fit];

    const previewOutput = `
      <div class="product-fit-guide__dimension product-fit-guide__dimension--${fit}">
        <strong>${title}:</strong>
        <p>
          ${fit === 'arch' ? 'Good Arch Support' : 'True to Size'} -
          <span class="green-text">
            ${fit === 'arch' ? percent(data[4], total) : percent(data[3], total)}
          </span>
        </p>
      </div>
    `;

    const breakdownOutput = `
      <div class="product-fit-guide__breakdown-category">
        <strong>
          ${title} <span>(${total} ${total === 1 ? 'Review' : 'Reviews' })<span>
        </strong>
        <ul>
          <li>${labels[1]}: <span>${percent(data[1], total)}</span></li>
          <li>${labels[2]}: <span>${percent(data[2], total)}</span></li>
          <li>${labels[3]}: <span>${percent(data[3], total)}</span></li>
          <li>${labels[4]}: <span>${percent(data[4], total)}</span></li>
          <li>${labels[5]}: <span>${percent(data[5], total)}</span></li>
        </ul>
      </div>
    `;

    preview.insertAdjacentHTML('beforeend', previewOutput);
    breakdownWrap.insertAdjacentHTML('beforeend', breakdownOutput);
  };

  bindBreakdownToggleEvent(breakdownToggle, breakdown);
  selector.classList.add('product-fit-guide--visible');
  fitScroll.style.display = 'block';
}

function bindBreakdownToggleEvent(toggle, target) {
  let open = false;

  toggle.addEventListener('click', () => {
    if (!open) {
      toggle.textContent = 'Hide Breakdown';
      target.classList.remove('product-fit-guide__breakdown--hidden');
      open = true;
    } else {
      toggle.textContent = 'View Breakdown';
      target.classList.add('product-fit-guide__breakdown--hidden');
      open = false;
    }
  });
}

function percent(num, total) {
  return Math.round(num / total * 100) + '%';
};

function capitalize(string) {
  return string[0].toUpperCase() + string.slice(1);
};
